<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="861px"
    top="30vh"
    append-to-body
    :show-close="false"
    custom-class="common-activity-dialog annual-celebration-dialog"
  >
    <div class="dialog-main">
      <slot></slot>
      <img class="img-bg" src="./images/dialog-bg.png" />
      <div class="btn-box">
        <img
          class="btn"
          src="./images/cancel.png"
          alt=""
          @click="closeDialog"
        />
        <img class="btn" src="./images/confirm.png" alt="" @click="save" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'CommonActivityDialog',
  props: {},
  data() {
    return {
      visible: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    openDialog() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    save() {
      this.$emit('save');
    }
  }
};
</script>
<style lang="scss" scoped></style>
<style lang="scss">
.common-activity-dialog {
  padding: 0;
  font-size: 0;
  background: rgba(0, 0, 0, 0);
  .el-dialog__body {
    padding: 0;
    width: 100%;
  }
  // .van-dialog__footer {
  //   display: none;
  // }
  &.annual-celebration-dialog {
    .dialog-main {
      position: relative;
      width: 100%;
    }
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: center;
      // justify-content: space-around;
      position: absolute;
      bottom: dPx(20);
      left: 0;
      width: 100%;
    }
    .img-bg {
      width: 100%;
      height: auto;
    }
    .btn {
      width: dPx(83);
      height: dPx(22);
      margin: 0 20px;
    }
  }
}
</style>
